export default {
  action_to_realize: "Actions to be carried out",
  sign_action: "Save and sign",
  complete: "Complete",
  toComplete: "To be completed",
  due_date: "Due date",
  toSign: "To be signed",
  description: "Description",
  yearProgression: "Yearly progress",
  progression: "Progress",
  your_progression: "Your completion rate",
  triad_progression: "Three-party group completion rate",
  missions_defined: "Defined missions",
  activities_described: "Described activities",
  question: "Question",
  incoming: "Waiting",
  signature: "Signature",
  questionnaire: "Questionnaire",
  questionnaires: "Questionnaires",
  yourAnswer: "Your response: ",
  answerHere: "Respond here",
  commentHere: "Leave a comment here",
  comment: "Comment response",
  answerComment: "Respond to comment",
  sendComment: "Post comment",
  sign: "Sign",
  draft: "Save draft",
  sharedDraft: "Save and share",
  stopSharedDraft: "Stop sharing the draft",
  stopSharedDraft_success: "Draft sharing disabled",
  downloadPdf: "Download questionnaire",
  downloadPdfModel: "Download template",
  interviewDate: "InseeCompany interview date",
  youAnswered: "You responded:",
  sendFile: "Send a file",
  sendDocument: "Send a document",
  takePicture: "Take a photo",
  fileSource: "File source",
  yesSign: "Yes, I want to sign",
  questionnaire_remove_title: "Delete a questionnaire",
  questionnaire_remove_sub_title: "Are you sure you want to delete this questionnaire?",
  copy_questionnaire: "Copy questionnaire",
  copy_questionnaire_title: "Copy of questionnaire “{title}”",
  questionnaire_copy_success: "Questionnaire copied successfully!",
  questionnaire_removed_success: "Questionnaire deleted successfully!",
  questionnaires_copied: "Questionnaire versions above",
  signMessage:
    "Are you sure you want to sign the questionnaire? You will no longer be able to edit your responses after signing.",
  row_add_success: "Line added successfully!",
  comment_add_success: "Comment added successfully!",
  deleteMessage: "Are you sure you want to delete this line?",
  download_report: "Download report",
  signatory: "Signatory",
  signatories: "Signatories",
  expected_signature: "Signature expected prior to",
  signed_on: "Signed on",
  commented_by: "Comment by",
  success: "Saved successfully!",
  draftSuccess: "Draft saved successfully!",
  sharedSuccess: "Draft shared successfully!",
  signedSuccess: "Signed successfully!",
  missionValidationError:
    "Unable to sign: please fill in the objective (or the comment if the mission is complete) for every mission in the block.",
  activityValidationError: "Unable to sign: please fill in the follow-up comment for every activity in the block.",
  questionnaireLoadingError: "An error occurred while loading the questionnaire. Please try again.",
  deletedQuestionnaire: "This questionnaire has been deleted",
  addLine: "Add row",
  "Competence calculated by your answers to the questionnaires":
    "Skill calculated using your responses to questionnaires",
  open_from: "Open from",
  no_crew_dates: "No dates for the group",
  open_to: "to",
  marks: "Notes",
  block_sign:
    "Signature of the questionnaire possible only after validation by the other two members of the three-party group.",
  no_mark: "No note currently available",
  "Download dates": "Download",
  "Print all the questionnaires": "Print all questionnaires",
  answered: "responded on",
  remove_answer_title: "Delete a line",
  remove_answer: "Are you sure you want to delete this response line?",
  to_be_completed_from: " To be completed from ",
  to: " to ",
  open_at: "Open on ",
  closed_at: "Clôturé au ",
  reopened: "Questionnaire ré-ouvert",
  signed_at: "Signé le ",
  export_questionnaire: "Export the questionnaire",
  import_questionnaire: "Import a questionnaire",
  no_questionnaire: ({ plural }) =>
    plural([
      "No questionnaire has been completed for this year",
      "No questionnaire has been completed for this category",
    ]),
  note: {
    title: ({ plural }) => plural(["Score", "Scores"]),
    question: {
      title: "Question score",
    },
    cluster: {
      title: "Grid score",
    },
    questionnaire: {
      title: "Questionnaire scores",
    },
    use_note_for_questionnaire: {
      title: "Include the score in the final score of the questionnaire.",
    },
    coefficient: "Coefficient",
    coefficient_help:
      "Allows you to weight the importance of this rubric compared to the other rubrics in the questionnaire." +
      "\n Example: You have 2 rubrics" +
      "\n - 'Theory' rubric with coefficient 2" +
      "\n - 'Practical' rubric with coefficient 3" +
      "\n The 'Practical' rubric will count 1.5 times more in the final grade.",
    coefficient_question_help: "Multiplier applied to the final score of this rubric",
    convertion: "Final grade scale",
    convertion_help:
      "Defines the scale on which the final grade will be adjusted after calculating the average of all questions in this rubric." +
      "\n Example: You have 5 questions graded out of 2 points each." +
      "\n - If you enter 20, the average will be converted to a score out of 20." +
      "\n - If the learner scores 8/10, the final grade will be 16/20.",
    convertion_question_help: "The score for this question will be converted to this scale",
    question_conversion: "Scale per question",
    question_conversion_help:
      "Defines the display scale for each question in this rubric. The score obtained cannot exceed the maximum points of the question!" +
      "\n Case 1: Question worth 5 points" +
      "\n - Scale per question = 20" +
      "\n The displayed grades will be: 5/20, 4/20, 3/20, etc. (the grade remains limited to 5 points)." +
      "\n Case 2: Question worth 5 points" +
      "\n - Scale per question = 4" +
      "\n Grades will be capped: 4/4, 3/4, 2/4, etc. (the possible 5 points are reduced to a maximum of 4).",
    question_conversion_question_help: "Maximum possible score for this question",
    see_details: "See score details",
    details: "Details",
    mark_detail: "Score detail",
    average: "Average",
    mark_scale: "Scale",
    maximal_mark: "Maximal score",
    minimal_mark: "Minimal score",
    maximal_mark_upper_than_mark_converted: "The maximum score cannot exceed the score displayed.",
    maximal_mark_for_question: "The maximum score for this question is:",
    maximal_mark_with_value: "Maximal score : {mark1}/{mark2}",
    error: {
      no_genral_mark:
        "The scoring system is enabled for this question. Please also enter the general scoring scale for the questionnaire by clicking here.\n",
    },
    leave_empty: "Leave blank if the maximum mark is the same as in the list of choices.",
  },
  summary_sheet: {
    title: "Notes summary",
    average: "Average",
  },
  empty_comment_label: "Commentaire",
  completeness_date_between_triad_start_date_and_end_date:
    "The completion date must be between the opening and closing dates of the members of the tripartite committee.",
  lock_questionnaire_heading: "Lock/unlock the header position",
  questionnaire_focus_scroll: "Automatically scroll to the active field",
  use_contract_date: "Opening based on the active contract dates of the tripartite committee",
  cluster: {
    required_error: "Warning, you must fill in at least one column",
  },
};
